import { HTMLTagRegEx } from "../../../../constants";
import { TValidator } from "../../../wizard/types";

const validator: TValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {};

  if (!values?.subjectId) {
    errors.subjectId = "The subject field is required.";
  }

  if (!values?.teachingLanguage) {
    errors.teachingLanguage = "The teaching language field is required.";
  }

  if (
    !values?.description ||
    !values.description.replace(HTMLTagRegEx, "").trim().length
  ) {
    errors.description = "The description field is required.";
  }

  if (Object.keys(errors).length > 0) {
    throw errors;
  }
};

export default validator;
